import { ServerResponse, IncomingMessage } from 'http';
import { Redirect } from 'next';
import SearchBanner from 'src/page-components/404/SearchBanner';
import Page from 'src/shared-components/Page/Page';
import ViewedDrugsContainer from 'src/shared-components/ViewedDrugs/ViewedDrugsContainer';

export interface CustomErrorProps {
  hasError: boolean;
  statusCode: number;
}

export const triggerCustomStatusCodeRedirect = (
  res: ServerResponse<IncomingMessage>,
  statusCode: number,
  сustomDestination?: string
): { redirect: Redirect } | { props: CustomErrorProps } => {
  // These are codes allowed to pass as status code with redirect field
  const allowedRedirectCodes = [301, 302, 303, 307, 308];

  if (res) res.statusCode = statusCode;

  if (allowedRedirectCodes?.includes(statusCode)) {
    return {
      redirect: {
        destination: сustomDestination ?? `/${statusCode}`,
        ...(allowedRedirectCodes?.includes(statusCode) && { statusCode })
      } as Redirect
    };
  }

  return {
    props: {
      hasError: true,
      statusCode
    }
  };
};

export const useHandleCustomErrorRedirect = (props: CustomErrorProps) => {
  const { statusCode } = props;

  const redirectToStatusCodePage = () => {
    return (
      <Page className="relative">
        <SearchBanner searchInputRef={null} errorCode={statusCode.toString()} />
        <div className="bg-white pt-8">
          <ViewedDrugsContainer />
        </div>
      </Page>
    );
  };

  return {
    redirectToStatusCodePage
  };
};
